import React from 'react';
import themes from '../themes';
import logger from '../utils/logger';

const theme = themes.darkLuxury.colors;

/**
 * Catches render errors in child components so the whole app does not white-screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('React ErrorBoundary caught:', error?.message || error, errorInfo?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const message =
      this.state.error?.message ||
      'Something went wrong while loading this page.';

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          background: theme.bodyBg,
          color: theme.textPrimary,
        }}
      >
        <div
          style={{
            maxWidth: '480px',
            textAlign: 'center',
            padding: '32px',
            borderRadius: '12px',
            border: theme.glassBorder,
            background: theme.glassBg,
          }}
        >
          <h1 style={{ margin: '0 0 12px', fontSize: '1.5rem' }}>Something went wrong</h1>
          <p style={{ margin: '0 0 24px', color: theme.textSecondary, lineHeight: 1.5 }}>
            {message}
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button type="button" className="btn btn-primary" onClick={this.handleReload}>
              Reload page
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.handleHome}
              style={{
                background: 'transparent',
                border: theme.glassBorder,
                color: theme.textPrimary,
              }}
            >
              Back to markets
            </button>
          </div>
        </div>
      </div>
    );
  }
}
